import React, {Component} from 'react'
import { validateEmail } from '../../utils/helpers'
import { tokenCreate, customerUpdate, customerUpdateByAdmin } from '../../utils/Customer'

class InfoEdit extends Component {
  constructor(props) {
    super(props)
    const currentYear = new Date().getFullYear()
    const numArr = []
    let i = 0
    while (i < 100) {
      numArr.push(i)
      i += 1
    }
    const birth = props.customer.birth?.value
    const gender = props.customer.tags.filter(tag => tag.includes('Gender:'))[0]
    this.state = {
      customer: props.customer,
      phone: props.customer?.phone,
      month: birth?.split('-')[1],
      currentYear: currentYear,
      year: parseInt(birth?.split('-')[0]),
      numArr,
      day: birth?.split('-')[2],
      days: numArr.slice(1,32),
      gender: gender?.replace('Gender:', '') || '',
      errorMessages: {
        firstName: null,
        lastName: null,
        email: null,
        emailConfirmation: null,
        currentPassword: null,
        newPassword: null,
        confirmPassword: null,
      },
      dirty: false,
      saving: false,
    }
    console.log('this.state', this.state)
    this.widgetRef = React.createRef()
  }

  getLastDay() {
    if(['04', '06', '09', '11'].includes(this.state.month)) {
      return 30
    } else if(this.state.month == '02') {
      let leapYear = false
      if(this.state.year % 400 == 0) {
        leapYear = true
      } else if(this.state.year % 100 == 0) {
        leapYear = false
      } else if(this.state.year % 4 == 0) {
        leapYear = true
      }
      return leapYear ? 29 : 28
    }
    return 31
  }

  getElements() {
    const widget = this.widgetRef.current
    return {
      firstName: widget.querySelector('#firstName').value?.trim(),
      lastName: widget.querySelector('#lastName').value?.trim(),
      email: widget.querySelector('#email').value?.trim(),
      emailConfirmation: widget.querySelector('#emailConfirmation').value?.trim(),
      phone: widget.querySelector('#phone').value?.replace(/ /g,'').replace(/-/g,'').replace(/\(/g,'').replace(/\)/g,''),
      currentPassword: widget.querySelector('#currentPassword').value?.trim(),
      newPassword: widget.querySelector('#newPassword').value?.trim(),
      confirmPassword: widget.querySelector('#confirmPassword').value?.trim(),
      birth: `${widget.querySelector('#year')?.value}-${widget.querySelector('#month')?.value}-${widget.querySelector('#date')?.value}`,
    }
  }

  updateButton() {
    setTimeout(() => {
      const { firstName, lastName, email, emailConfirmation, phone, newPassword, confirmPassword, birth } = this.getElements()
      const dirty = (firstName !=  this.state.customer.firstName) ||
        (lastName !=  this.state.customer.lastName) ||
        (email !=  this.state.customer.email) ||
        (emailConfirmation !=  this.state.customer.email) ||
        (phone !=  this.state.phone) ||
        !!newPassword ||
        !!confirmPassword ||
        (birth != '--' && (!this.state.customer.birth || (!!this.state.customer.birth && this.state.customer.birth.value != birth))) ||
        !this.state.customer.tags.includes(`Gender:${this.state.gender}`)
      
      this.setState({ dirty })
    }, 100)
  }

  componentDidMount() {
    const infoForm = document.querySelector('[data-info-form]')
    const infoDetails = document.querySelector('[data-info-details]')
    this.widgetRef.current.querySelector('[data-info-form-cancel]').addEventListener('click', () => {
      infoDetails.classList.remove('!hidden')
      infoForm.classList.add('!hidden')
    })

    const infoSave = this.widgetRef.current.querySelector('[data-info-form-save]')
    infoSave.addEventListener('click', () => {
      const { firstName, lastName, email, emailConfirmation, phone, currentPassword, newPassword, confirmPassword, birth } = this.getElements()
      
      let validation = true
      if(!firstName) {
        this.setState({ errorMessages: { firstName: 'First name is required' } })
        validation = false
      }
      if(!lastName) {
        this.setState({ errorMessages: { lastName: 'Last name is required' } })
        validation = false
      }
      if(!email) {
        this.setState({ errorMessages: { email: 'Email is required' } })
        validation = false
      }
      if(!validateEmail(email)) {
        this.setState({ errorMessages: { email: 'Email is invalid' } })
        validation = false
      }
      if(email && validateEmail(email) && email != emailConfirmation) {
        this.setState({ errorMessages: { emailConfirmation: "Email doesn't match" } })
        validation = false
      }
      
      if(!currentPassword) {
        this.setState({ errorMessages: { currentPassword: 'Current password is required' } })
        validation = false
      }
      if(!!newPassword && newPassword.length < 5) {
        this.setState({ errorMessages: { newPassword: "Password should be at least 5 letters" } })
        validation = false
      }
      if(!!newPassword && newPassword != confirmPassword) {
        this.setState({ errorMessages: { confirmPassword: "Password doesn't match" } })
        validation = false
      }
      const tags = this.state.customer.tags
      let newTags = []
      tags.forEach(tag => {
        if(!tag.includes('Gender:')) newTags.push(tag)
      })
      if(!!this.state.gender) newTags = newTags.concat([`Gender:${this.state.gender}`])
      if(validation) {
        // infoSave.disabled = true
        this.setState({ saving: true })
        tokenCreate((token) => {
            if(token) {
              const variables = {
                email,
                firstName,
                lastName,
                phone: phone ? phone : null,
              }
              if(!!newPassword) variables['password'] = newPassword
              let newErrors = null
              customerUpdate((data) => {
                  console.log('customerUpdate', data)
                  if(data.userErrors.length) {
                    const phoneError = data.userErrors.filter(error => error.field.includes('customer') && error.field.includes('phone'))[0]
                    if(phoneError) {
                      this.setState({ errorMessages: { phone: `It already exists or it is invalid. ${phoneError.message}` } })
                    }
                    newErrors = data.userErrors
                  } else {
                    this.setState({
                      customer: Object.assign(this.state.customer, {
                        email,
                        firstName: firstName,
                        lastName: lastName,
                        phone
                      })
                    })
                  }
                },
                token,
                variables
              )
              customerUpdateByAdmin(customer => {
                  this.setState({ customer: customer })
                },
                { 
                  customer: Object.assign(
                    {
                      id: this.state.customer.id,
                      tags: newTags,
                      phone: phone ? phone : null,
                    },
                    birth == '--' || birth.includes('YYYY') || birth.includes('MM') || birth.includes('DD') ? {} : {
                      metafields: [
                        this.state.customer.birth ?
                        {
                          id: this.state.customer.birth.id,
                          value: birth
                        }:
                        {
                          namespace: "custom",
                          key: "birth",
                          type: "date",
                          value: birth
                        }
                      ]
                    }
                  )
                }
              )
              setTimeout(() => {
                if(!newErrors) {
                  location.reload()
                } else {
                  this.setState({ saving: false })
                }
              }, 1200)
            } else {
              this.setState({ errorMessages: { currentPassword: 'Current password is wrong' } })
              // infoSave.disabled = false
              this.setState({ saving: false })
            }
          }, 
          this.state.customer.email,
          currentPassword
        )
      }
    })
  }

  render() {
    return (
      <div className='flex flex-col gap-x-3.75 gap-y-11 pb-12.5' ref={this.widgetRef}>
        <div className='grid lg:grid-cols-2 gap-x-3.75 gap-y-11'>
          <div className={`input-wrap ${!!this.state.customer.firstName ? 'input-wrap__filled' : ''}`}>
            <input type='text' 
              id='firstName' 
              defaultValue={ this.state.customer.firstName || '' } 
              placeholder={window.accountStrings.personalInfo.form.firstName} 
              onChange={e => {
                this.setState({ errorMessages: { firstName: null } })
                this.updateButton()
              }}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target?.value)
              }}
            />
            <label htmlFor='firstName'>{window.accountStrings.personalInfo.form.firstName}</label>
            { this.state.errorMessages.firstName && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.firstName }</div> }
          </div>
          <div className={`input-wrap ${!!this.state.customer.lastName ? 'input-wrap__filled' : ''}`}>
            <input type='text' 
              id='lastName' 
              defaultValue={ this.state.customer.lastName || ''} 
              placeholder={window.accountStrings.personalInfo.form.lastName} 
              onChange={e => {
                this.setState({ errorMessages: { lastName: null } })
                this.updateButton()
              }}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
              }}
            />
            <label htmlFor='lastName'>{window.accountStrings.personalInfo.form.lastName}</label>
            { this.state.errorMessages.lastName && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.lastName }</div> }
          </div>
        </div>
        <div className={`input-wrap ${!!this.state.customer.email ? 'input-wrap__filled' : ''}`}>
          <input type='email' 
            id='email' 
            defaultValue={ this.state.customer.email || '' } 
            placeholder={window.accountStrings.personalInfo.form.email}
            onChange={e => {
              this.setState({ errorMessages: { email: null } })
              this.updateButton()
            }}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
          />
          <label htmlFor='email'>{window.accountStrings.personalInfo.form.email}</label>
          { this.state.errorMessages.email && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.email }</div> }
        </div>
        <div className={`input-wrap ${!!this.state.customer.email ? 'input-wrap__filled' : ''}`}>
          <input type='email' 
            id='emailConfirmation' 
            defaultValue={ this.state.customer.email || '' } 
            placeholder={window.accountStrings.personalInfo.form.emailConfirmation}
            onChange={e => {
              this.setState({ errorMessages: { emailConfirmation: null } })
              this.updateButton()
            }}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
          />
          <label htmlFor='emailConfirmation'>{window.accountStrings.personalInfo.form.emailConfirmation}</label>
          { this.state.errorMessages.emailConfirmation && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.emailConfirmation }</div> }
        </div>
        <div className='grid lg:grid-cols-2 gap-x-3.75 gap-y-11'>
          <div className={`input-wrap ${!!this.state.phone ? 'input-wrap__filled' : ''} ${this.state.errorMessages.phone ? 'input-error' : ''}`}>
            <input type='tel' 
              id='phone' 
              defaultValue={ this.state.phone || '' } 
              placeholder={window.accountStrings.personalInfo.form.phone}
              onChange={e => {
                this.setState({ errorMessages: { phone: null } })
                this.updateButton()
              }}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
              }}
            />
            <label htmlFor='phone'>{window.accountStrings.personalInfo.form.phone}</label>
            { this.state.errorMessages.phone && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.phone }</div> }
          </div>
          <div className='normal-case hidden lg:flex items-end pb-2'>
            {window.accountStrings.personalInfo.form.needToContact?.replace('&lt;br&gt;', "\n")}
          </div>
        </div>
        
        <div className='relative'>
          <div className='normal-case mb-2.5 text-fourth-grey absolute bottom-full left-0'>{window.accountStrings.personalInfo.form.birth}</div>
          <div className='grid lg:grid-cols-3 gap-x-3.75 gap-y-3.75'>
            <div className='select-wrap'>
              <select
                id='month' 
                defaultValue={this.state.month}
                onChange={e => {
                  this.setState({ month: e.target.value })
                  this.updateButton()
                }}
              >
                {
                  ['MM', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((day, index) =>
                    <option value={ index == 0 ? '' : (index < 10 ? `0${index}` : index)} 
                      key={`month-${index}`}
                    >
                      { day }
                    </option>
                  )
                }
              </select>
            </div>
            <div className='select-wrap'>
              <select id='date' defaultValue={this.state.day} onChange={e => {
                this.setState({ day: e.target.value })
                this.updateButton()
              }}>
                <option value=''>DD</option>
                {
                  this.state.days.slice(0, this.getLastDay()).map(day =>
                    <option value={day < 10 ? '0' + day : day} key={`day-${day}`} onChange={e => this.setState({ day: e.target.value })}>
                      { day }
                    </option>
                  )
                }
              </select>
            </div>
            <div className='select-wrap'>
              <select id='year' defaultValue={this.state.year} onChange={e => {
                this.setState({ year: e.target.value })
                this.updateButton()
              }}>
                <option value=''>YYYY</option>
                {
                  this.state.numArr.map(num => 
                    <option value={ this.state.currentYear - num } key={`year-${num}`}>
                      { this.state.currentYear - num }
                    </option>
                  )
                }
              </select>
            </div>
          </div>
        </div>
        
        <div className='grid lg:grid-cols-2 gap-x-3.75 gap-y-11'>
          <div className='select-wrap'>
            <label htmlFor='gender'>{window.accountStrings.personalInfo.form.gender}</label>
            <select id='gender' defaultValue={this.state.gender} onChange={e => {
              this.setState({ gender: e.target.value })
              this.updateButton()
            }}>
              <option value=''></option>
              <option value='female'>{window.accountStrings.personalInfo.form.female}</option>
              <option value='male'>{window.accountStrings.personalInfo.form.male}</option>
            </select>
          </div>
        </div>
        <div className='relative mt-7'>
          <div className='mb-8 absolute bottom-full left-0'>{window.accountStrings.personalInfo.form.password}</div>
          <div className='grid lg:grid-cols-3 gap-x-3.75 gap-y-11'>
            <div className='input-wrap'>
              <input type='password' 
                id='currentPassword' 
                placeholder={window.accountStrings.personalInfo.form.currentPassword}
                onChange={e => {
                  this.setState({ errorMessages: { currentPassword: null } })
                }}
                onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                onBlur={e => {
                  e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
                }}
              />
              <label htmlFor='currentPassword'>{window.accountStrings.personalInfo.form.currentPassword}</label>
              { this.state.errorMessages.currentPassword && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.currentPassword }</div> }
            </div>
            <div className='input-wrap'>
              <input type='password' 
                id='newPassword' 
                placeholder={window.accountStrings.personalInfo.form.newPassword}
                onChange={e => {
                  this.setState({ errorMessages: { newPassword: null } })
                  this.updateButton()
                }}
                onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                onBlur={e => {
                  e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
                }}
              />
              <label htmlFor='newPassword'>{window.accountStrings.personalInfo.form.newPassword}</label>
              { this.state.errorMessages.newPassword && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.newPassword }</div> }
            </div>
            <div className='input-wrap'>
              <input type='password' 
                id='confirmPassword' 
                placeholder={window.accountStrings.personalInfo.form.confirmPassword}
                onChange={e => {
                  this.setState({ errorMessages: { confirmPassword: null } })
                  this.updateButton()
                }}
                onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                onBlur={e => {
                  e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
                }}
              />
              <label htmlFor='confirmPassword'>{window.accountStrings.personalInfo.form.confirmPassword}</label>
              { this.state.errorMessages.confirmPassword && <div className='text-tb-red text-[0.625rem] absolute top-full left-0'>{ this.state.errorMessages.confirmPassword }</div> }
            </div>
          </div>
        </div>

        <div className='grid lg:grid-cols-2 gap-x-3.75 gap-y-11'>
          <button className='button button--secondary' data-info-form-cancel>
            {window.accountStrings.personalInfo.form.cancel}
          </button>
          <button className={`button relative ${this.state.dirty ? 'button--primary' : 'button--secondary'} ${this.state.saving ? 'button--loading' : ''}`}
            data-info-form-save
            disabled={!this.state.dirty || this.state.saving}
          >
            {window.accountStrings.personalInfo.form.save}
            <div className="button--loading__pane">
              <span className="button--loading__dot"></span>
              <span className="button--loading__dot"></span>
              <span className="button--loading__dot"></span>
            </div>
          </button>
        </div>
      </div>
    )
  }
}

export default InfoEdit